module.exports = __webpack_public_path__ + "static/media/report-button-trim-none.2cbcf69e.svg";